/* Swaps the card panel in the visual mega menu when a sidebar item with
   children is hovered or focused. Without JS every panel except the overview
   stays hidden and the sidebar links still work as plain navigation. */

class MegaVisualMenu extends HTMLElement {
  connectedCallback() {
    this.panels = Array.from(this.querySelectorAll('[data-mega-panel-id]'));
    this.triggers = Array.from(this.querySelectorAll('[data-mega-panel]'));
    if (!this.panels.length || !this.triggers.length) return;

    // A panel swap can still nudge the layout. If that slides a different
    // sidebar item under a stationary pointer the browser fires mouseenter
    // without any real movement, which would swap the panel straight back and
    // flicker. Only honour a hover that follows an actual pointer move.
    this.pointerMoved = false;
    this.addEventListener('mousemove', () => {
      this.pointerMoved = true;
    }, { passive: true });

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => {
        if (!this.pointerMoved) return;
        this.pointerMoved = false;
        this.activate(trigger);
      });
      trigger.addEventListener('focus', () => {
        // Every panel sits after the whole sidebar in DOM order, so a sub-panel
        // has to stay open while focus moves through the remaining sidebar
        // links — otherwise its cards could never be tabbed to. The overview
        // cards duplicate the sidebar links, so nothing becomes unreachable.
        if (trigger.dataset.megaPanel !== 'overview') this.activate(trigger);
      });
    });

    const details = this.closest('details');
    if (details) {
      details.addEventListener('toggle', () => {
        if (!details.open) this.reset();
      });
    }
  }

  activate(trigger) {
    const id = trigger.dataset.megaPanel;
    if (id === this.current) return;
    this.current = id;

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.megaPanelId !== id;
    });

    this.triggers.forEach((item) => {
      const isCurrent = item === trigger;
      item.classList.toggle('mega-visual__side-link--current', isCurrent);
      if (item.hasAttribute('aria-expanded')) {
        item.setAttribute('aria-expanded', isCurrent ? 'true' : 'false');
      }
    });
  }

  reset() {
    this.current = 'overview';
    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.megaPanelId !== 'overview';
    });
    this.triggers.forEach((item) => {
      item.classList.remove('mega-visual__side-link--current');
      if (item.hasAttribute('aria-expanded')) item.setAttribute('aria-expanded', 'false');
    });
  }
}

if (!customElements.get('mega-visual-menu')) {
  customElements.define('mega-visual-menu', MegaVisualMenu);
}
